var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00341 16.001C6.42126 16.001 4.87464 15.5318 3.55913 14.6528C2.24361 13.7738 1.2183 12.5244 0.612836 11.0627C0.00737229 9.60102 -0.151044 7.99258 0.157618 6.44083C0.46628 4.88908 1.22816 3.46371 2.34691 2.34496C3.46566 1.22621 4.89103 0.464327 6.44279 0.155665C7.99454 -0.152998 9.60297 0.00541916 11.0647 0.610882C12.5264 1.21635 13.7758 2.24166 14.6548 3.55717C15.5337 4.87268 16.0029 6.4193 16.0029 8.00146C16.0005 10.1223 15.157 12.1556 13.6573 13.6553C12.1576 15.155 10.1243 15.9986 8.00341 16.001ZM3.50341 7.16596C3.353 7.16559 3.20596 7.21046 3.08138 7.29473C2.95679 7.379 2.86043 7.49878 2.80479 7.63852C2.74915 7.77826 2.73682 7.9315 2.76938 8.07834C2.80195 8.22518 2.87791 8.35884 2.98741 8.46196L6.25891 11.5505C6.40261 11.6843 6.59309 11.7565 6.78942 11.7514C6.98576 11.7464 7.17228 11.6645 7.30891 11.5235L13.0404 5.52346C13.1777 5.37944 13.2521 5.18681 13.2473 4.98793C13.2425 4.78904 13.1589 4.60021 13.0149 4.46296C12.8709 4.32571 12.6783 4.25129 12.4794 4.25607C12.2805 4.26085 12.0917 4.34444 11.9544 4.48846L6.74641 9.94396L4.01941 7.36996C3.88019 7.23885 3.69615 7.16588 3.50491 7.16596H3.50341Z",
    fill: "#29E191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.a81851a7b11c305ea9f02c84cbaea62c.svg";
export { ForwardRef as ReactComponent };